import CloseIcon from '@src/assets/images/common/icon/close.svg';

const AttachmentErrorModal = ({ fileName, attachmentErrorMessage: errorMessage, onClose }: {
  fileName: string;
  attachmentErrorMessage: string;
  onClose: () => void;
}) => {
  return (
    <div className='chat-attachment-list relative z-[9999]'>
      <div className='fixed inset-0 z-40 bg-black opacity-30'></div>
      <div className='fixed inset-0 z-50 grid place-items-center'>
        <div className='relative max-w-[400px] w-[90%] rounded bg-white p-6 shadow-[0_0_8px_rgba(0,0,0,0.25)]'>
          <p className='truncate border-b border-solid border-b-gray-350 pb-4 text-[18px] font-semibold'>
            {fileName}
          </p>
          <p className='mt-4 text-sm text-gray-700'>{errorMessage}</p>
          <button
            className='absolute right-[8px] top-[8px] grid size-5 place-items-center rounded-full bg-gray-50'
            onClick={onClose}
          >
            <img
              src={CloseIcon}
              alt='閉じる'
              width={16}
              height={16}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttachmentErrorModal;
